import React, { useEffect } from "react";
import logging from "utils/logging";
import { Container, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useSelector } from "react-redux";
import { Navigate, useLocation } from 'react-router-dom';
import { selectDestination, selectUserIsAuthed, selectAuthUnavailable } from "./authSlice";
import { SignIn, SignUp } from "@clerk/clerk-react";
import Analytics from "analytics";
import { EVENTS } from "analytics/events";
import { clearAuthReturnPath, getAuthReturnPath } from "./authReturnPath";
import AuthUnavailable from "./AuthUnavailable";

const log = logging.getLogger("Groupardy Auth"); //eslint-disable-line no-unused-vars

const Root = styled('div')(({ theme }) => ({
  height: "100%",
  margin: 0,
}));

const Headline = styled(Typography)(({ theme }) => ({
  color: "white",
  textAlign: "center",
  margin: theme.spacing(3),
}));

const GroupardyAuth = () => {
  const userIsAuthed = useSelector(selectUserIsAuthed);
  const authUnavailable = useSelector(selectAuthUnavailable);
  const dest = useSelector(selectDestination);
  const location = useLocation();
  const isSignUp = location.pathname === "/signup";
  const savedReturnPath = getAuthReturnPath();
  const redirectUrl = dest || savedReturnPath || "/manage";

  useEffect(() => {
    if (!userIsAuthed) {
      Analytics.track(EVENTS.SIGNUP_STARTED, {
        entry_point: location.state?.from || document.referrer || "direct",
        auth_route: location.pathname,
        has_redirect_destination: !!dest,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (userIsAuthed) {
    log.debug("User authed. Redirecting to: ", redirectUrl);
    clearAuthReturnPath();
    return <Navigate to={redirectUrl} replace />;
  }

  // Clerk couldn't initialize — render a clear error instead of an empty
  // SignIn widget that silently fails to mount.
  if (authUnavailable) {
    return <AuthUnavailable />;
  }

  return (
    <Root>
      <Headline variant="h2">
        Sign In to Groupardy
      </Headline>
      <Container maxWidth="sm">
        {isSignUp ? (
          <SignUp
            forceRedirectUrl={redirectUrl}
            fallbackRedirectUrl={redirectUrl}
            signInUrl="/login"
          />
        ) : (
          <SignIn
            forceRedirectUrl={redirectUrl}
            fallbackRedirectUrl={redirectUrl}
            signUpUrl="/signup"
            withSignUp
          />
        )}
      </Container>
    </Root>
  );
};

export default GroupardyAuth;
